import { useEffect, useState } from 'react'
import { UseCheckUsage, UseCheckUsageProps } from './types'
import { METER_TYPES } from '@boltenergy-be/shared'

export const useCheckUsage = ({ hasExclusiveNightMeter, meterType, usage }: UseCheckUsageProps): UseCheckUsage => {
  // Local state
  const [isValidUsage, setIsValidUsage] = useState<boolean>(false)

  // Constants
  const MAX_USAGE = 100000

  /**
   * Triggered everytime usage, hasNightMeter or hasExclusiveNightMeter changes
   * Checks if the usage is valid
   */
  useEffect(() => {
    // If no usage is given, it is not valid
    if (!usage) {
      setIsValidUsage(false)
      return
    }

    // If the gas usage is larger than 100.000 kWh (100MWh), it is not valid
    if (usage.gas && Number(usage.gas) > MAX_USAGE) {
      setIsValidUsage(false)
      return
    }

    // Calculate the total electricity usage
    let totalElectricityUsage = 0

    if (meterType === METER_TYPES.single) {
      totalElectricityUsage = Number(usage?.electricity?.consumption?.single ?? 0)
    } else {
      totalElectricityUsage =
        Number(usage?.electricity?.consumption?.double?.day ?? 0) + Number(usage?.electricity?.consumption?.double?.night ?? 0)
    }

    if (hasExclusiveNightMeter) {
      totalElectricityUsage += Number(usage?.electricity?.consumption?.exclusiveNight ?? 0)
    }

    // If the total electricity usage is larger than 100.000 kWh (100MWh), it is not valid
    if (totalElectricityUsage > MAX_USAGE) {
      setIsValidUsage(false)
      return
    }

    // Usage is valid
    setIsValidUsage(true)

    // Cleanup
    return () => {
      setIsValidUsage(false)
    }
  }, [usage, meterType, hasExclusiveNightMeter])

  return {
    isValidUsage
  }
}
